/**
 * Utility to invalidate queries after stream payments are processed
 */
export function invalidateStreamPaymentQueries(
  queryClient: any,
  artistId: string,
  sponsorId: string,
) {
  if (!queryClient) return;

  // Invalidate artist-related queries
  queryClient.invalidateQueries({ queryKey: ["artistWallet", artistId] });
  queryClient.invalidateQueries({ queryKey: ["artistProfile", artistId] });

  // Invalidate sponsor-related queries
  queryClient.invalidateQueries({ queryKey: ["sponsorWallet", sponsorId] });
  queryClient.invalidateQueries({ queryKey: ["sponsorProfile", sponsorId] });
  queryClient.invalidateQueries({ queryKey: ["sponsorAnalytics", sponsorId] });

  // Invalidate general queries
  queryClient.invalidateQueries({ queryKey: ["tracks"] });
  queryClient.invalidateQueries({ queryKey: ["transactions"] });

  console.log(
    "🔄 Invalidated queries after stream payment for artist:",
    artistId,
    "sponsor:",
    sponsorId,
  );
}
